import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Terms() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl pb-24">
      <div className="mb-6">
        <Link to="/settings">
          <Button variant="ghost" size="sm">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Settings
          </Button>
        </Link>
      </div>

      <h1 className="text-2xl font-bold mb-6">Terms of Service</h1>

      <div className="prose prose-invert max-w-none space-y-6">
        <p className="text-muted-foreground">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section>
          <h2 className="text-xl font-semibold mb-3">Acceptance of Terms</h2>
          <p className="text-muted-foreground">
            By using FlexTrack, you agree to these Terms of Service. If you do not agree,
            please do not use the app.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Description of Service</h2>
          <p className="text-muted-foreground">
            FlexTrack is a personal tracking tool for gig economy workers to log work blocks,
            track mileage, and monitor earnings. The app is intended for personal record-keeping
            and tax documentation purposes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">User Responsibilities</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-2">
            <li>You are responsible for the accuracy of data you enter</li>
            <li>You must keep your account credentials secure</li>
            <li>You agree to use the app only for lawful purposes</li>
            <li>You must be at least 18 years old to use this service</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Disclaimer</h2>
          <p className="text-muted-foreground">
            FlexTrack is provided "as is" without warranties of any kind. We do not guarantee
            the accuracy of mileage calculations or earnings data. This app is not affiliated
            with Amazon, Amazon Flex, or any delivery service provider.
          </p>
          <p className="text-muted-foreground mt-2">
            The mileage and earnings data provided by this app should not be considered
            official tax documentation. Please consult a tax professional for tax-related advice.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Limitation of Liability</h2>
          <p className="text-muted-foreground">
            To the maximum extent permitted by law, we shall not be liable for any indirect,
            incidental, special, or consequential damages arising from your use of the app.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Account Termination</h2>
          <p className="text-muted-foreground">
            You may delete your account at any time through the Settings page. We reserve
            the right to terminate accounts that violate these terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Changes to Terms</h2>
          <p className="text-muted-foreground">
            We may update these terms from time to time. Continued use of the app after
            changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">Contact</h2>
          <p className="text-muted-foreground">
            For questions about these terms, please contact us through the app or at the
            email provided in your App Store listing.
          </p>
        </section>
      </div>
    </div>
  );
}
